import useAuthorizationStore from './UseAuthorizationStore';
var useRoleStore = function () { return useAuthorizationStore().roleStore; };
export default useRoleStore;
//# sourceMappingURL=UseRoleStore.js.map